<template>
	<div class="impact-details">
		<div class="impact-details__content">
			<div class="impact-details__header">
				<span class="impact-details__header-title">
					Impact Details
				</span>

				<Button
					:className="'btn--icon-only-circle'"
					labelText=""
					:btnClick="formsHistory"
					iconClassName="icon-history"
					:iconBeforeLabel="true"
				/>
			</div>

			<hr class="impact-details__header-horizontal-line" />

			<div class="form-info-items">
				<div class="form-info-items__name">
					<span class="impact-details-title">Form Name</span>
					<p class="impact-details-text">
						{{ this.form && this.form.name }}
					</p>
				</div>

				<div class="form-info-items__revision">
					<span class="impact-details-title">Form Revision</span>
					<p class="impact-details-text">
						{{ this.form && this.form.formRevision }}
					</p>
				</div>

				<div class="form-info-items__description">
					<span class="impact-details-title">Form Description</span>
					<p class="impact-details-text">
						{{ this.form && this.form.description }}
					</p>
				</div>
			</div>

			<div class="impact-details__main-content">
				<ImpactDetailsContent v-model="form.impactInputFields" />
			</div>
		</div>
	</div>
</template>

<script>
import Button from '@/components/forms/button/button';
import ImpactDetailsContent from '@/views/form-designer/impact-details-content.vue';
import BaseComponent from '@/mixins/base-component';
import _ from 'lodash';

export default {
	name: 'ImpactDetails',
	mixins: [BaseComponent],
	model: {
		prop: 'form'
	},
	components: {
		Button,
		ImpactDetailsContent
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		labelInsideClassName: {
			type: String,
			default: ''
		},
		btnClick: {
			type: Function,
			default: () => {}
		},
		autoSave: {
			type: Boolean,
			default: true
		},
		formData: {
			type: Object
		},
		refreshList: {
			type: Boolean,
			default: false
		},
		form: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			privilegedUser: true,
			resultTextarea: '',
			classNameInput: 'textarea__input',
			placeholder: '',
			formSaveValue: {
				text: 'Save',
				value: 'default'
			},
			formSaveOptions: [
				{
					text: 'Save',
					value: 'default'
				},
				{
					text: 'Cancel',
					value: 'cancel'
				}
			],
			navigatingFromCustomer: false
		};
	},
	created() {
		this.navigatingFromCustomer = _.startsWith(
			this.$route.path,
			'/clients'
		);
	},
	computed: {
		customerPath() {
			if (_.isEmpty(this.$route.params.customerId)) {
				return '';
			}

			return `/clients/${this.$route.params.customerId}`;
		}
	},
	methods: {
		formsHistory() {
			if (this.navigatingFromCustomer) {
				this.$router.push({
					path: `${this.customerPath}/forms/${this.form.id}/history/`
				});
				return;
			}
			this.$router.push({
				path: `${this.customerPath}/forms/history/${
					this.form.id
				}/${encodeURIComponent(this.form.name)}`
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
  * [Description]
  *
  * Impact Form details
  * Can use SCSS variables = TRUE
  *
  *
**/

.impact-details {
	&__content {
		background: $white;
		padding: $padding-md;
		flex-direction: column;
		flex-wrap: wrap;
		display: flex;
		margin-bottom: $gutter-xxl;

		@include mq($until: sm-l) {
			border-top: 1px solid $neutral-3;
		}

		@include mq($from: sm-l) {
			border: 1px solid $neutral-3;
			border-radius: 4px;
		}
	}

	&__header-horizontal-line {
		@include create-horizontal-line(16px, 1px, $gutter-lg, $neutral-3);
	}

	&__header {
		display: flex;
		justify-content: space-between;
		align-items: center;

		&-title {
			color: $black;
			font-size: $default-font-size;
			font-weight: $medium-font-weight;
		}
		.btn {
			font-size: 24px;
		}
	}
}

.form-info-items {
	display: flex;
	flex-wrap: wrap;
	gap: 2%;
	margin-top: $gutter-xl;
	margin-bottom: $gutter-xxl;
	@include mq($from: lg) {
		margin-bottom: $gutter-xl;
	}
}

.impact-details-title {
	font-weight: $medium-font-weight;
	font-size: $label-font-size;
	margin-bottom: $gutter-sm;
	display: block;
}

.impact-details-text {
	font-size: 14px;
}

.form-info-items {
	&__name,
	&__revision,
	&__description {
		min-width: 100%;
		.impact-details-title {
			margin-bottom: $gutter-md;
		}
	}

	&__name,
	&__revision {
		@include mq($from: md) {
			min-width: 49%;
		}

		@include mq($from: lg) {
			min-width: 20%;
		}
	}

	&__revision,
	&__description {
		margin-top: $gutter-xl;
		@include mq($from: md) {
			margin-top: 0;
		}
	}

	&__description {
		@include mq($from: md) {
			margin-top: $gutter-xl;
		}
		@include mq($from: lg) {
			margin-top: 0;
			min-width: 56%;
			max-width: 56%;
		}
	}
}
</style>
